import React from 'react';
import GoogleLogin from 'containers/Login';
import VanillaLogin from 'containers/LoginTenant';
import { getTenantPreLoginConfig } from 'tenant/teanantPreLoginConfig';

const LoginContainer = (props) => {
  const loginConfig = getTenantPreLoginConfig().login_component;

  const LoginContainers = {
    vanilla: VanillaLogin,
    google: GoogleLogin,
  };

  const LoginComponent = LoginContainers[loginConfig];

  return <LoginComponent {...props} />;
};

export default LoginContainer;
